import createConsts from './consts';

const REQUEST_CONSTS = [
  'SEND',
  'SUCCEED',
  'REJECTED',
  'ERROR_ENCOUNTERED',
  'ADD_META',
  'CLEAR',
];

export default (module, submodule, additionalConstants = []) =>
  createConsts(module, submodule, ...REQUEST_CONSTS, ...additionalConstants);



// WEBPACK FOOTER //
// ./src/utils/redux/req-consts.js